// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats {
  height: 100vh;
  height: 100dvh;
}

.stats__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  padding: 0 var(--pad) calc(env(safe-area-inset-bottom, 0px) + 28px);
}

.stats__hl {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin: 6px 0 26px;
}
.hlitem {
  background: var(--palette-surface);
  border: 1px solid var(--palette-border);
  border-radius: 14px;
  padding: 14px 10px;
  text-align: center;
}
.hlitem__val {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.7rem;
  line-height: 1;
}
.hlitem__val.accent {
  color: var(--palette-primary);
}
.hlitem__label {
  font-size: 0.64rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--palette-text-muted);
  margin-top: 6px;
}

.stats__sec-head {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 2px;
}
.stats__sec-sub {
  font-size: 0.78rem;
  color: var(--palette-text-muted);
  margin-bottom: 12px;
}

table.records {
  width: 100%;
  border-collapse: collapse;
}
.stats .premium-card {
  margin-top: 18px;
}
.records th {
  font-size: 0.62rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--palette-text-muted);
  font-weight: 600;
  text-align: right;
  padding: 0 0 8px;
}
.records th:first-child {
  text-align: left;
}
.records td {
  padding: 11px 0;
  border-top: 1px solid var(--palette-border);
  text-align: right;
  font-size: 0.95rem;
}
.records td:first-child {
  text-align: left;
  font-weight: 600;
}
.records .v {
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}
.records .rank {
  font-variant-numeric: tabular-nums;
}
.records a {
  color: var(--palette-secondary);
  text-decoration: none;
  font-weight: 600;
  font-size: 0.85rem;
}
`, "",{"version":3,"sources":["webpack://./src/screens/playerStatsScreen.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".stats {\n  height: 100vh;\n  height: 100dvh;\n}\n\n.stats__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior-y: contain;\n  padding: 0 var(--pad) calc(env(safe-area-inset-bottom, 0px) + 28px);\n}\n\n.stats__hl {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  margin: 6px 0 26px;\n}\n.hlitem {\n  background: var(--palette-surface);\n  border: 1px solid var(--palette-border);\n  border-radius: 14px;\n  padding: 14px 10px;\n  text-align: center;\n}\n.hlitem__val {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.7rem;\n  line-height: 1;\n}\n.hlitem__val.accent {\n  color: var(--palette-primary);\n}\n.hlitem__label {\n  font-size: 0.64rem;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--palette-text-muted);\n  margin-top: 6px;\n}\n\n.stats__sec-head {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.2rem;\n  margin-bottom: 2px;\n}\n.stats__sec-sub {\n  font-size: 0.78rem;\n  color: var(--palette-text-muted);\n  margin-bottom: 12px;\n}\n\ntable.records {\n  width: 100%;\n  border-collapse: collapse;\n}\n.stats .premium-card {\n  margin-top: 18px;\n}\n.records th {\n  font-size: 0.62rem;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--palette-text-muted);\n  font-weight: 600;\n  text-align: right;\n  padding: 0 0 8px;\n}\n.records th:first-child {\n  text-align: left;\n}\n.records td {\n  padding: 11px 0;\n  border-top: 1px solid var(--palette-border);\n  text-align: right;\n  font-size: 0.95rem;\n}\n.records td:first-child {\n  text-align: left;\n  font-weight: 600;\n}\n.records .v {\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n}\n.records .rank {\n  font-variant-numeric: tabular-nums;\n}\n.records a {\n  color: var(--palette-secondary);\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
